import { useEffect } from 'react'

export const HUBSPOT_PORTAL_ID = '51322079'
export const HUBSPOT_REGION = 'na1'
export const HUBSPOT_SUBSCRIBE_FORM_ID = 'b661b732-51be-4058-bd41-f9dc33e8babe'

const HUBSPOT_EMBED_SRC = `https://js.hsforms.net/forms/embed/${HUBSPOT_PORTAL_ID}.js`

export interface HubSpotFormProps {
  /** HubSpot form GUID (data-form-id). Defaults to the subscribe form. */
  formId?: string
  /** HubSpot data-region. */
  region?: string
  /** Optional class on the frame, used to scope styling overrides. */
  className?: string
}

/**
 * Renders a HubSpot form through the portal embed script.
 */
export const HubSpotForm = ({
  formId = HUBSPOT_SUBSCRIBE_FORM_ID,
  region = HUBSPOT_REGION,
  className
}: HubSpotFormProps) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${HUBSPOT_EMBED_SRC}"]`)) return
    const script = document.createElement('script')
    script.src = HUBSPOT_EMBED_SRC
    script.defer = true
    document.body.appendChild(script)
  }, [])

  return (
    <div
      className={className ? `hs-form-frame ${className}` : 'hs-form-frame'}
      data-region={region}
      data-form-id={formId}
      data-portal-id={HUBSPOT_PORTAL_ID}
    />
  )
}

export default HubSpotForm
